import {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from 'react';

const VotesContext = createContext();

const STORAGE_KEY = 'votes';

export const VotesProvider = ({ children }) => {
  // Инициализируем состояние из localStorage (один раз)
  const [votes, setVotes] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  });

  // При каждом изменении votes сохраняем в localStorage
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(votes));
  }, [votes]);

  // Опционально: синхронизация между вкладками браузера
  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === STORAGE_KEY && e.newValue) {
        setVotes(JSON.parse(e.newValue));
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  // Функция для безопасного обновления голосов
  const setVote = useCallback((voteId, value) => {
    setVotes((prevVotes) => {
      // Не меняем состояние, если значение не изменилось
      if (prevVotes[voteId] === value) return prevVotes;
      return { ...prevVotes, [voteId]: value };
    });
  }, []);

  return (
    <VotesContext.Provider value={{ votes, setVote }}>
      {children}
    </VotesContext.Provider>
  );
};

// Кастомный хук для удобного использования контекста
export const useVotes = () => {
  const context = useContext(VotesContext);
  if (!context) {
    throw new Error('useVotes must be used within a VotesProvider');
  }
  return context;
};
